export default function WooFavourite() {
	// Setup our vars
	const addButtons = document.querySelectorAll('.js-add-favourite');
	const removeButtons = document.querySelectorAll('.js-remove-favourite');

	// Check for add buttons
	if (addButtons.length) {
		// Loop over our add icons
		addButtons.forEach(function(addButton) {
			// Add our click event to trigger
			addButton.addEventListener('click', function() {

				// Set the id of the clicked item
				const id = addButton.getAttribute('data-id');
				const user = addButton.getAttribute('data-user');

				// Check for a valid ID
				if (id) {
					// Add to favourites
					fetch('/api/add-favourite/' + id + '/' + user, {
						method: "POST",
					})
						.then(function(response) {
							// Reload the page on response
							location.reload();
						});
				}
			});
		});
	}

	// Check for remove buttons
	if (removeButtons.length) {
		// Loop over our remove icons
		removeButtons.forEach(function(removeButton) {
			// Add our click event to trigger
			removeButton.addEventListener('click', function() {

				// Set the id of the clicked item
				const id = removeButton.getAttribute('data-id');
				const user = removeButton.getAttribute('data-user');

				// Check for a valid ID
				if (id) {
					// Remove from favourites
					fetch('/api/remove-favourite/' + id + '/' + user, {
						method: "POST",
					})
						.then(function(response) {
							// Reload the page on response
							location.reload();
						});
				}
			});
		});
	}
}
